import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class Invigilator extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			exhall : '',
			employee : '',
			term : '',
			exam : '',
			edate : '',
			etime : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			posts: [],
			employ : [],
			terms : [],
			data : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("inviform").reset();
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.exhall && this.state.employee && this.state.term && this.state.exam && this.state.edate && this.state.etime){
			
			PostData('exam/addinvigilator',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Invigilator Assign Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("inviform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('exam/deleteinvi',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Invigilator Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	componentDidMount() {
		 
		this.gethall();
		this.getemployee();
		this.getterms();
		this.getdata();
	}
	
	getdata(){
		
		GetData('exam/getinvigilator').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/* get Exam Hall */
	gethall(){
		
		GetData('exam/gethall').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/* getemployee */
	getemployee(){
		
		GetData('employee/getemployee').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					employ : responseJson
				});
			}
		});
	}
	
	/*getterms*/
	getterms(){
		
		GetData('exam/getterms').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					terms : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}
	
	var items = this.state.posts;
	var emp = this.state.employ;
	var ter = this.state.terms;
	
	/** get Exam By Term **/
	$("#term").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'exam/getexambyterm/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#exam").html('');
			$('#exam')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Exam- ')); 
			$.each(o,function(key,value){			
				   $('#exam')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.exam)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
	/** get Exam Date By Term & Exam **/
	$("#exam").change(function(){
		var fr = $(this).val();
		var tr = $("#term").val();
		$.get(GLOBAL.BASE_URL+'exam/getdatebyexamandterm/'+tr+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#exdate").html('');
			$('#exdate')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Exam Date- ')); 
			$.each(o,function(key,value){			
				   $('#exdate')
					.append($("<option></option>")
					.attr("value",value.examdate)
					.text(value.examdate)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
	/** get Exam Time By Term & Exam & Exam Date **/
	$("#exdate").change(function(){
		var fr = $(this).val();
		var tr = $("#term").val();
		var er = $("#exam").val();
		$.get(GLOBAL.BASE_URL+'exam/gettimebyexamandtermanddate/'+tr+'/'+er+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#extime").html('');
			$('#extime')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Exam Time- ')); 
			$.each(o,function(key,value){			
				   $('#extime')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.extime)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="inviform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Assign Invigilator</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Exam Hall <span className="text-danger">*</span></Label>
							  <select name="exhall" onChange={this.onChange} className="form-control" required> 
								<option value="">Select Hall</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.hallno}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
							  <select name="employee" onChange={this.onChange} className="form-control" required>
								<option value="">Select Employee</option>
								{
									emp.map(function (item) {
										return <option value={item.id }>{item.empname}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Term <span className="text-danger">*</span></Label>
							  <select name="term" onChange={this.onChange} className="form-control" required id="term">
								<option value="">Select Terms</option>
								{
									ter.map(function (item) {
										return <option value={item.id }>{item.term}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Exam Name <span className="text-danger">*</span></Label>
							  <select name="exam" onChange={this.onChange} className="form-control" id="exam">
																
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Exam Date <span className="text-danger">*</span></Label>
							  <select name="edate" onChange={this.onChange} className="form-control" id="exdate">
																
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Exam time <span className="text-danger">*</span></Label>
							  <select name="etime" onChange={this.onChange} className="form-control" id="extime">
																
							  </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Employee Name</th>
							<th>Exam Hall</th>
							<th>Exam Name</th>
							<th>Exam Date</th>
							<th>Exam Time</th>
							<th width="100">Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.data.map(item =>
						 
							<tr key = {item}>
								<td>{item.id}</td>
								<td>{item.empname}</td>
								<td>{item.hallno}</td>
								<td>{item.exam}</td>
								<td>{item.examdate}</td>
								<td>{item.examtime}</td>
								<td>
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>

						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Invigilator;


// WEBPACK FOOTER //
// ./src/examhall/Invigilator/Invigilator.js